<form [formGroup]="form" autocomplete="off" class="form-horizontal">

  <div class="form-check">
    <input class="form-check-input" datevMessagePath="isGesellschaftOrgantraeger{{objectId}}"
           formControlName="isGesellschaftOrgantraeger"
           id="isGesellschaftOrgantraeger"
           type="checkbox" utilsCheckValidity
           utilsControlState utilsValidationMessage>
    <label class="form-check-label" for="isGesellschaftOrgantraeger">
      {{ 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFTSVERHAELTNISSE.ORGANTRAEGER.GESELLSCHAFT_IST_ORGANTRAEGER' | translate }}
    </label>
  </div>

  <div class="form-check">
    <input class="form-check-input" datevMessagePath="isOrgantraegerschaftKStUndGewSt{{objectId}}"
           formControlName="isOrgantraegerschaftKStUndGewSt"
           id="isOrgantraegerschaftKStUndGewSt"
           type="checkbox" utilsCheckValidity
           utilsControlState utilsValidationMessage>
    <label class="form-check-label" for="isOrgantraegerschaftKStUndGewSt">
      {{ 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFTSVERHAELTNISSE.ORGANTRAEGER.ORGANTRAEGERSCHAFT_IST_KST_UND_GEWST' | translate }}
    </label>
  </div>

  <div class="form-check">
    <input class="form-check-input" datevMessagePath="isOrgantraegerschaftUmsatzsteuerlich{{objectId}}"
           formControlName="isOrgantraegerschaftUmsatzsteuerlich"
           id="isOrgantraegerschaftUmsatzsteuerlich"
           type="checkbox" utilsCheckValidity
           utilsControlState utilsValidationMessage>
    <label class="form-check-label" for="isOrgantraegerschaftUmsatzsteuerlich">
      {{ 'COMMON_UI.FRAGEBOGEN.ORGANSCHAFTSVERHAELTNISSE.ORGANTRAEGER.ORGANTRAEGERSCHAFT_IST_UMSTATZSTEUERLICH' | translate }}
    </label>
  </div>
</form>
